<ng-container *ngFor="let phone of contact?.allPhones">
  <div tooltip class="phone-number"
    [ngClass]="{ 'selected-number': phone.number === contact.selectedPhoneNumber }"
    (click)="selectPhoneNumber(contact, phone)"
  >{{ phoneNumberType(phone) }}</div>
</ng-container>
